import { gql } from '@apollo/client'

const ADD_CUSTOM_PRODUCTS = gql`
  mutation AddCustomProducts(
    $organizationId: String
    $storeId: String
    $partRequests: [CustomPartRequestInput]
  ) {
    addCustomProducts(
      organizationId: $organizationId
      storeId: $storeId
      partRequests: $partRequests
    ) {
      id
      quantity
      inStock
      availableAt
      externalId
      taskNumber
      suggestion
      product {
        id
        mpn
        altMpn
        name
        store {
          id
        }
      }
      unitPrice {
        currency
        amount
      }
      discountedUnitPrice {
        currency
        amount
      }
      extendedPrice {
        currency
        amount
      }
    }
  }
`

export default ADD_CUSTOM_PRODUCTS
